import React, { Component, useEffect, useState } from "react";
import List from "../../Components/Invoices/TradeUnionsRequests";
import DetailItem from "../../Components/Invoices/TradeUnionRequest";
import Status from "../../Components/Invoices/Modals/Status";

import {
  ContainerRequest,
  ContainerRequestsTradeUnions,
  ContainerTradeUnions,
} from "../../Components/ContainerSoftware/ContainerElements";
import axiosConfig from "../../ApiCall/axiosConfig";
import { ToastContainer, toast } from "react-toastify";
import { Slide } from "react-toastify";
const Products = () => {
  const [items, setItems] = useState([]);
  const [searchItems, setSearchItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const [status, setStatus] = useState([]);
  const [filters, setFilters] = useState([]);

  const [detailItem, setDetailItem] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModalStatus, setShowModalStatus] = useState(false);

  const handleOpenModal = (modal) => {
    if (modal === "modalStatus") {
      setShowModalStatus(true);
    }
  };
  const handleCloseModal = (modal) => {
    if (modal === "modalStatus") {
      setShowModalStatus(false);
    }
  };
  const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
  const params = new URLSearchParams([
    ["per_page", 100],
    ["page", 1],
  ]);

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    },
    params,
  };

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      try {
        const { data } = await axiosConfig.get("/company/invoices", config);
        const itemsData = data.data;
        setItems(itemsData);
        setSearchItems(itemsData);
        setFilterItems(itemsData);
      } catch (error) {
        console.log("Error fetching roles:", error);
      }
    }
    async function fetchFilters() {
      try {
        const { data } = await axiosConfig.get("/company/status/list", config);
        const itemsData = data.data;
        setFilters(itemsData);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching roles:", error);
      }
    }
    fetchData();
    fetchFilters();
  }, []);
  const handleAddStatus = (toastId, statuses, statusDetail) => {
    setDetailItem({
      ...detailItem,
      status: statusDetail,
      statuses: statuses,
    });

    async function fetchData() {
      try {
        const { data } = await axiosConfig.get("/company/invoices", config);
        const itemsData = data.data;
        let filtereditemsData;
        if (status === 0) {
          filtereditemsData = itemsData.filter((item1) =>
            items.some(
              (item2) => item2.id === item1.id && item2.id !== detailItem.id
            )
          );
        } else {
          filtereditemsData = itemsData.filter((item1) =>
            items.some((item2) => item2.id === item1.id)
          );
        }
        setItems(filtereditemsData);
        setFilterItems(filtereditemsData);
        setSearchItems(itemsData);
        toast.update(toastId, {
          render: "وضعیت با موفقیت به فاکتور اختصاص داده شد",
          type: "success",
          isLoading: false,
          autoClose: 3000,
          closeOnClick: true,
        });
      } catch (error) {
        console.log("Error fetching ctegories:", error);
      }
    }
    fetchData();
  };

  const handleSelectItem = (detailItem) => {
    setDetailItem(detailItem);
  };
  const filter = (e) => {
    const keyword = e.target.value;
    if (keyword !== "") {
      let results = items.filter((item) => {
        return (
          item?.branch?.title.toLowerCase().includes(keyword.toLowerCase()) ||
          item?.branch?.trade_unit?.title
            .toLowerCase()
            .includes(keyword.toLowerCase()) ||
          item?.number
            ?.toString()
            .toLowerCase()
            .startsWith(keyword.toLowerCase())
        );
      });
      setItems(results);
    } else {
      setItems(filterItems);
    }
  };
  const filterStatus = (status) => {
    setStatus(status);
    if (status !== 0) {
      let results = searchItems.filter((item) => {
        return item?.status?.id === status;
      });
      setItems(results);
      setFilterItems(results);
    } else {
      setItems(searchItems);
      setFilterItems(searchItems);
    }
  };
  return (
    <>
      <ContainerRequestsTradeUnions>
        {loading ? (
          <div className="loadingList">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <ContainerTradeUnions>
              <List
                handleOpenModal={handleOpenModal}
                handleSelectItem={handleSelectItem}
                data={items}
                filter={filter}
                filterStatus={filterStatus}
                filters={filters}
              />
              <Status
                showModalStatus={showModalStatus}
                handleCloseModal={handleCloseModal}
                handleAddStatus={handleAddStatus}
                itemDetails={detailItem}
              />
            </ContainerTradeUnions>
            <ContainerRequest>
              <DetailItem
                detailItem={detailItem}
                handleOpenModal={handleOpenModal}
              ></DetailItem>
            </ContainerRequest>
          </>
        )}
      </ContainerRequestsTradeUnions>
    </>
  );
};

export default Products;
